import { Container } from './styles'

interface IProps {
  children: React.ReactNode
}

export const Menu = ({ children }: IProps) => {
  return <Container>{children}</Container>
}
